import { createContext, useContext } from 'react';
import { DropdownPlacement } from '~/components/Dropdown/Dropdown.hooks';

export type CelectContextValue = {
  active: boolean;
  value?: string;
  placement: DropdownPlacement;
  closeOnClick?: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setValue: (value: string) => void;
};

export const CelectContext = createContext<CelectContextValue>({
  active: false,
  open: () => {},
  close: () => {},
  toggle: () => {},
  placement: 'bottom',
  setValue: () => {},
});

export const useCelect = () => useContext(CelectContext);
